unable to read source [project]/node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/src/class-registry.ts